<template>
  <v-container
    style="height:100%"
    class="d-flex justify-center align-center mt-4"
  >
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="
            $router.push(
              `/equipment/${repairProfile.equipmentProfile.id}/repairlog`
            )
          "
        >
          <v-icon>mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <span>{{ $t("repairLogProfile.backbtn") }}</span>
    </v-tooltip>

    <v-card v-if="repairProfile && repairProfile.equipmentProfile">
      <v-card-title
        class="primary white--text d-flex justify-center text-center text-uppercase"
        >{{ this.$t("repairLogProfile.title") }}</v-card-title
      >

      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="6" justify="center" align="center">
            <v-text-field
              filled
              readonly=""
              v-model="repairProfile.equipmentProfile.equipTag"
              :label="this.$t('repairLogProfile.tag')"
            ></v-text-field>
          </v-col>
          <!--         <v-col cols="12" sm="6" justify="center" align="center">
            <v-text-field
              filled
              readonly=""
              v-model="repairProfile.client"
              label="Customer"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" sm="6" justify="center" align="center">
            <v-text-field
              filled
              readonly=""
              :value="
                filterEquipmentType(
                  repairProfile.equipmentProfile.equipmentType
                )
              "
              :label="this.$t('repairLogProfile.type')"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" justify="center" align="center">
            <v-text-field
              filled
              readonly=""
              v-model="user.email"
              :label="this.$t('repairLogProfile.createdby')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" justify="center" align="center">
            <v-text-field
              filled
              v-model="dateFixed"
              :label="this.$t('repairLogProfile.date')"
              readonly=""
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col cols="12" justify="center" align="center">
            <v-textarea
              counter
              row-height="30"
              filled
              readonly=""
              v-model="repairProfile.log"
              :label="this.$t('repairLogProfile.log')"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-divider class="my-12"></v-divider>
        <v-btn
          :disabled="!$store.getters['auth/adminAndUp']"
          color="primary"
          class="my-2"
          @click="desactivarItem()"
        >
          <v-icon class="my-auto" dark color="white">
            mdi-cancel
          </v-icon>
          {{ this.$t("repairLogProfile.deletebtn") }}
        </v-btn>
      </v-container>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { db } from "@/plugins/db";

import equipmentType from "@/mixins/equipmentType";
export default {
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch("repairs/bindARepair", this.$route.params.id);
    loading.close();
  },
  components: {},
  data: () => ({
    snack: false,
    snackColor: "",
    snackText: ""
  }),

  mixins: [equipmentType],
  computed: {
    dateFixed() {
      if (this.$root.$i18n.locale === "es") {
        return moment
          .unix(this.repairProfile.dateCreated.seconds)
          .locale("es")
          .format("MMMM D YYYY, h:mm:ss a");
      } else {
        return moment
          .unix(this.repairProfile.dateCreated.seconds)
          .format("MMMM D YYYY, h:mm:ss a");
      }
    },

    ...mapState("repairs", ["repairProfile"]),
    ...mapState("auth", ["user"])
  },
  methods: {
    desactivarItem() {
      db.collection("repairProfile")
        .doc(this.repairProfile.id)
        .update({ disabled: true })
        .then(() => {
          this.$router.push({ path: "/" });
        });
    }
  }
};
</script>

<style></style>
